define(function(require,exports,module){   
    var jdHeaderAndFooter = {
        init: function() {
            var u = navigator.userAgent.toLowerCase();

            // jdhapp 京东健康
            if(u.indexOf("jdapp") != -1 || u.indexOf("jdjr") != -1 || u.indexOf("kepler") != -1 || u.indexOf("micromessenger") != -1 || u.indexOf("jdhapp") != -1 || u.indexOf("yhdapp") != -1 || u.indexOf("mxxqapp") != -1 ) {
                return false;
            }

            var param = new Object();
            var sid = $("#sid").val();
            var title = $("#title").val();
            var link = $("#link").val();
            var mchb = new MCommonHeaderBottom();

            if(null != sid && sid.length>0){
                param.sid = sid;
            }
            if(null != title && title.length>0){
                param.title = title;
            }
            if(null != link && link.length>0){
                param.link = link;
            }

            //加载头部
            // if(location.href.indexOf("jd.hk") > -1) {
            //     var tpl = require("../../template/header");
            //     var render = template.compile(tpl.tpl);
            //     var html = render({});
            //     $("#m_common_header").append(html);
            // } else {
                var headerArg = {hrederId : 'm_common_header', title:title, sid : sid, isShowShortCut : false, selectedShortCut : '4'}
                mchb.header(headerArg);
            // }
            $(".header").css("border-top", "0");
        },
    };
    exports.loadHeadAndFooter = jdHeaderAndFooter.init;
});


// WEBPACK FOOTER //
// ./src/js/unit/headerFooter/headerFooter.js